var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 6h-2v23c0 .42-.08.8-.23 1.17-.16.37-.37.68-.64.95-.28.28-.6.5-.96.65-.36.15-.75.23-1.17.23H7c-.42 0-.8-.08-1.17-.23-.37-.16-.68-.37-.96-.64-.27-.28-.48-.6-.64-.96C4.08 29.8 4 29.42 4 29V6H2V4h8V2c0-.28.05-.54.16-.78.1-.24.24-.45.43-.63.15-.2.36-.36.6-.46.24-.1.5-.16.8-.16h6c.26 0 .52.04.76.15.24.1.45.24.63.43.2.17.33.38.43.62.1.24.16.5.16.78v2h8v2zM12 4h6V2h-6v2zm12 2H6v23c0 .27.1.5.3.7.2.2.43.3.7.3h16c.27 0 .5-.1.7-.3.2-.2.3-.43.3-.7V6zM12 26h-2V10h2v16zm4 0h-2V10h2v16zm4 0h-2V10h2v16z"
  }))));
};
export default SvgDelete;